// import { Autocomplete, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from '@mui/icons-material/Close';
// import { CSVLink } from "react-csv";

// import CustomTextField from "../../../../../components/utils/input/customTextField";

// const StockverificationMismatchReport = () => {
//     const classes = useStyle()
//     const dispatch = useDispatch();
//     const pageOption = [10, 25, 50, 100];
//     const [page, setPage] = useState(0);
//     // const [rowsPerPage, setRowsPerPage] = useState(100);
//     const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);

//     // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//     const [pageCount, setPageCount] = useState(0);
//     const [data, setData] = useState([]);
//     const [supplier, setSupplier] = useState([]);
//     const [catData,setCatData] = useState([])
//     const [subData,setSubData] = useState([])
//     const [activeStep , setActiveStep] = useState("0")
//     const [rowData , setRowData] = useState(null)
//     const outletName = localStorage.getItem('outlet_name')
//     const [allSubData, setAllSubData] = useState([]);
//     const [barcode, setBarcode] = useState("");
//     const [isOutletLoading, setIsOutletLoading] = useState(true);

//     const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
//     const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
//   const [dateLimit, setDateLimit] = useState({
//     fromDate : moment().startOf('month').format(),
//     toDate :  moment().format()
//   })
//   const [options, setOptions] = useState({
//     customer : null,
//     category : null,
//     subCategory : null
// })
// const onEdit = (e) => {
//   console.log(e.row)
//   setActiveStep("1")
//   setRowData(e.row)
// }
// function handleOptions(value, name){
//     console.log(name, value)
//     // setOptions(prev=>({...prev,[name] : value}))
//     setOptions((prev) => ({ ...prev, [name]: value }));
//         if (name === "category") {
//           setOptions((prev) => ({ ...prev, subCategory: null }));
//           filterSubCategories(value ? value.id : null);
//         }
// }
// function filterSubCategories(categoryId) {
//   if (categoryId) {
//     const filteredSubData = allSubData.filter(
//       (sub) => sub.category_id === categoryId
//     );
//     setSubData(filteredSubData);
//   } else {
//     setSubData([]);
//   }
// }
// const columns = [
//   {
//     field : 'sno',
//     headerName : 'S.no',
//     minWidth : 70,
//     maxWidth : 100,
//     headerAlign : 'center',
//     align : 'center',
//     sortable: false
//   },
//   {
//     field: "otName",
//     headerName: "Outlet Name",
//           width: 100,
//   minWidth:150,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
// //   {
// //     field: "docno",
// //     headerName: "Doc No",
// //           width: 100,
// //   minWidth: 200,
// //     headerAlign: "center",
// //     align: "center",
// //     sortable: false,
// //   },
//   {
//     field: "code",
//     headerName: "Product Barcode",
//     // flex: 1,
//       width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     width:180,
//   },
//   {
//     field: "item",
//     headerName: "Product Description",
//           width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     width:180,
//   },
//   {
//     field: "category",
//     headerName: "Category",
//           width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     width:180,
//   },
//   {
//     field: "subcategory",
//     headerName: "SubCategory",
//           width: 100,
//   minWidth: 200,
//      width:280,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "qty",
//     headerName: "Qty",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "amt",
//     headerName: "Amount",
//          width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "right",
//     sortable: false,
//     renderCell: (params) => (
//       <strong>{params.value}</strong>
//     ),
//   },
//    {
//     field: "actualot",
//     headerName:"Actual Outlet",
//          width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//    {
//     field: "scannedby",
//     headerName:"Scanned By",
//          width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//    {
//     field: "errorcode",
//     headerName:"Error Code",
//           width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//    {
//     field: "errormsg",
//     headerName:"Error Message",
//         width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//    {
//     field: "createdat",
//     headerName:"Created At",
//          width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },

// ]
// console.log(options.customer != null ? options.customer.fullname : outletName)
// const rows = _.map(data,(val,idx)=>({
//   // id: val.prodid,
//   id: val.id,
//   sno: idx+1,
//   code : val.barcode,
//   item : val.description,
//   qty : val.qty,
//   amt : parseFloat(val.mrp).toFixed(0),
//   otName: val.outlet_name,
//   docno: val.docno,
//   scannedby:val.scanned_by_name,
//   actualot : val.actual_outlet_name ==="No Outlet" ?"Warehouse":val.actual_outlet_name,
//   errorcode : val.error_code,
//   errormsg : val.error_message,
//   createdat : val.created_at,
//   category: val.category_name,
//   subcategory: val.subcategory_name

// }))
// const props = {
//   columns : columns,
//   rows : rows,
//   page: page,
//   setPage: setPage,
//   rowsPerPage: rowsPerPage,
//   setRowsPerPage: setRowsPerPage,
//   pageCount: pageCount,
//   pageOption: pageOption,
//   totalAmount:totalAmount,
//   totalFlag:totalFlag,

// }
// // useEffect(() => {
// //   // Calculate total balance amount
// //   setTotalFlag(true)
// //   let total = 0;

// //   data.forEach(val => {
// //       total += parseFloat(val.amount);
// //   });
// //   setTotalAmount(total.toFixed(0));
// // }, [data]);
// useEffect(() => {
//   setTotalFlag(true);

//   // total rows in current page
//   const total = rows.length;

//   setTotalAmount(total);
// }, [rows]);
//   function handleChange(e, name) {
//     setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
//   }
//   function getSupplierData() {
//     axios
//       .get("/v1/outlet/list/1")
//       .then((res) => {
//         console.log(res.data)
//         setSupplier(res.data);
//         const loggedOutletName = localStorage.getItem('outlet_name');
//       const userOutlet = res.data.find(outlet => outlet.fullname === loggedOutletName);
//       if (userOutlet) {
//         setOptions(prev => ({ ...prev, customer: userOutlet }));
//       }
//       setIsOutletLoading(false);
//     })
//       .catch((err) => {
//         setData([]);
//         setRowData(null);
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//         setIsOutletLoading(false);
//       });
//   }
//   function getCategory(){
//     axios.get('/v1/categories')
//     .then(res=>{
//         // _.filter(res.data, val=>{
//         //     if(val.is_active){
//         //          setCatData(res.data)
//         //     }
//         // })
//         const activeCats = res.data.filter(val => val.is_active);
// setCatData(activeCats);

//     })
//     .catch(err=>{
//       setData([]);
//       setRowData(null);
//         console.log(err)
//         dispatch(setSnackbar(true,'error',err.response.data.error))
//     })
// }
// // function getCategory() {
// //   axios.get("/v1/categories")
// //     .then(res => {
// //       // keep only active ones
// //       const activeCats = res.data.filter(cat => cat.is_active);
// //       setCatData(activeCats);
// //     })
// //     .catch(err => {
// //       console.error(err);
// //       dispatch(setSnackbar(true, "error", err.response?.data?.error || err.message));
// //     });
// // }

// function getSubCategory(){
//     axios.get('/v1/subcategories')
//     .then(res=>{
//             // setSubData(res.data)
//             setAllSubData(res.data);
//     })
//     .catch(err=>{
//         console.log(err)
//         setData([]);
//         setRowData(null);
//         dispatch(setSnackbar(true,'error',err.response.data.error))
//     })
// }
// // function handleOutletSalesItemWise(){
// //   const postData = {
// //     from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
// //     to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
// //       customer: options.customer !==null ? options.customer.id : 0,
// //       category : options.category !==null ? options.category.id : 0,
// //       subcategory : options.subCategory !==null ? options.subCategory.id : 0
// //   }
// //   axios.post('/v1/reports/outlet_sales/itemwise', postData)
// //   .then(res=>{
// //     setData(res.data)
// //     console.log(res)
// //     setPageCount(res.data.length)
// //   })
// //   .catch(err=>{
// //     setData([])
// //     setRowData(null)
// //   //   setCatData([])           // Clear table data
// //   // setPageCount(0);         // Reset pagination
// //   // setTotalAmount(0);       // Reset total amount
// //   // dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "Something went wrong"));
// //     dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
// //   })
// // }
// function handleOutletSalesItemWise() {
//   if (isOutletLoading) return;
//   // reset immediately so your table shows “no rows” until new data arrives
//   setData([]);
//   setRowData(null);
//   const postData = {
//     from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//     to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
//     // customer: options.customer?.id || 0,
//        category_name: options.category
//       ? options.category.category_name
//       : "",

//     subcategory_name: options.subCategory
//       ? options.subCategory.subcategory_name
//       : "",
//     outlet_id:options.customer?.id || 0,
//      barcode: barcode || "", 
//   };

//   axios.post(`/v1/stock_verify/error_report/${page_size}/${current_page}`, postData)
//  .then(res => {
//   setData(res.data.data);            
//   setPageCount(res.data.total || 0); 
// })

//     .catch(err => {
//       setData([]);
//       setRowData(null);


//       // setDateLimit({fromDate:"",toDate:""})

//       dispatch(setSnackbar(
//         true,
//         "error",
//         err.response?.data?.errors?.[0]?.message || "Something went wrong"
//       ));
//     });
// }


// const generateCSVData = () => {
//   const csvData = [
//     [
//       "S.no",
//       "Outlet Name",
//       "Product Barcode",
//       "Product Description",
//       "Category",
//       "SubCategory",
//       "Qty",
//       "Amount",
//       "Actual Outlet",
//       "Scanned By",
//       "Error Code",
//       "Error Message",
//       "Created At"
//     ]
//   ];

//   rows.forEach(row => {
//     csvData.push([
//       row.sno,
//       row.otName,
//       row.code,
//       row.item,
//       row.category,
//       row.subcategory,
//       row.qty,
//       row.amt,
//       row.actualot,
//       row.scannedby,
//       row.errorcode,
//       row.errormsg,
//       row.createdat
//     ]);
//   });

//   csvData.push([]);


//   return csvData;
// };

// useEffect(() => {
//     getSupplierData();
//     getCategory()
//     getSubCategory()
//   }, []);

//   // useEffect(()=>{
//   //   if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
//   //     handleOutletSalesItemWise()
//   //     console.log('Vanthuden')
//   //   }
//   // },[rowsPerPage, page, dateLimit,options,catData])
//   useEffect(() => {
//     if (dateLimit.fromDate && dateLimit.toDate) {
//       handleOutletSalesItemWise();
//     }
//   }, [
//     page,
//     rowsPerPage,
//     dateLimit.fromDate,
//     dateLimit.toDate,
//     options.customer,
//     options.category,
//     options.subCategory,
//       barcode,
//   ]);

//   console.log(rows,"datadata");


//   return (
//   <Fragment>
//     <Helmet><title>Stock Verify Mismatch Report</title></Helmet>
//    <Typography variant="h6">Stock Verify Mismatch Report</Typography>
//       <Grid container spacing={2} className="p-2 pt-2">
//         <Grid item md={3}>
//           <Autocomplete 
//             size="small"
//             options={[{id:0 , fullname :"All"} , ...supplier]}
//             value={options.customer || null}
//             onChange={(e,value)=>handleOptions(value,'customer')}
//             getOptionLabel={option=>option.fullname}
//             renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
//           />
//         </Grid>
//                <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'From',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//            <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'To',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//         <Grid item >
//         {/* <TextField
//         label="Barcode *"
//         variant="outlined"
//          sx={{
//          width: 300,
//          "& .MuiOutlinedInput-root": {
//           height: 42,
//          alignItems: "flex-end", 
//          },
//          "& input": {
//           padding: "14px 12px 6px 12px", 
//           },
//            }}
//           /> */}
//           <TextField
//   label="Barcode *"
//   variant="outlined"
//   value={barcode}
//   onChange={(e) => setBarcode(e.target.value)}
//   sx={{
//     width: 300,
//     "& .MuiOutlinedInput-root": {
//       height: 42,
//       alignItems: "flex-end",
//     },
//     "& input": {
//       padding: "14px 12px 6px 12px",
//     },
//   }}
// />


//         </Grid>
//         <Grid item md={3}>
//       <Autocomplete 
//         size='small'
//         value={options.category}
//         options={catData}
//         getOptionLabel={option=>option.category_name}
//         onChange={(e,value)=>handleOptions(value,'category')}
//         renderInput={(params)=>(
//             <TextField {...params}
//             label='Category'/>
//           )}
//         />
//       </Grid>
//       <Grid item md={3}>
//       <Autocomplete 
//         size='small'
//         options={subData}
//         value={options.subCategory}
//         disabled={options.category == null}
//         getOptionLabel={option=>option.subcategory_name}
//         onChange={(e,value)=>handleOptions(value,'subCategory')}
//         renderInput={(params)=>(
//             <TextField {...params}
//             label='Sub Category'/>
//           )}
//         />
//       </Grid>
//         {/* <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'From',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid> */}
//         {/* <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'To',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid> */}
//         <Grid item md={3}>
//             <CSVLink data={generateCSVData()} filename={"StockVerificationMismatch_Reports.csv"}>
//             <Button variant="contained" color="primary">
//               Download CSV
//             </Button>
//           </CSVLink>
//         </Grid>
//         <Grid item md={3}>

//         </Grid>
//         {/* <Grid item md={3} style={{ display: 'flex', alignItems: 'start',justifyContent:"end" }}>
//           <CSVLink data={generateCSVData()} filename={"StockVerificationMismatch_Reports.csv"}>
//             <Button variant="contained" color="primary">
//               Download CSV
//             </Button>
//           </CSVLink>
//         </Grid> */}
//       </Grid>
//        {activeStep === "0" ? 
//              <CustomTable props={props}/> 

//              : 
//              <Grid>
//               {/* <ByProdId setActiveStep={setActiveStep} options={options} setOptions={setOptions} dateLimit={dateLimit} setDateLimit={setDateLimit} rowData={rowData}/> */}
//              </Grid>
//              }
//   </Fragment>
//   )
// }

// export default memo(StockverificationMismatchReport)

// test
import { Autocomplete, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { CSVLink } from "react-csv";

import CustomTextField from "../../../../../components/utils/input/customTextField";
import CustomTable from "./customTable";

const StockverificationMismatchReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(pageOption[0]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [catData, setCatData] = useState([])
  const [subData, setSubData] = useState([])
  const [activeStep, setActiveStep] = useState("0")
  const [rowData, setRowData] = useState(null)
  const outletName = localStorage.getItem('outlet_name')
  const [allSubData, setAllSubData] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [isOutletLoading, setIsOutletLoading] = useState(true);

  const [totalAmount, setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag, setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().startOf('month').format(),
    toDate: moment().format()
  })
  const [options, setOptions] = useState({
    customer: null,
    category: null,
    subCategory: null
  })
  const onEdit = (e) => {
    console.log(e.row)
    setActiveStep("1")
    setRowData(e.row)
  }
  function handleOptions(value, name) {
    console.log(name, value)
    // setOptions(prev=>({...prev,[name] : value}))
    setOptions((prev) => ({ ...prev, [name]: value }));
    if (name === "category") {
      setOptions((prev) => ({ ...prev, subCategory: null }));
      filterSubCategories(value ? value.id : null);
    }
  }
  function filterSubCategories(categoryId) {
    if (categoryId) {
      const filteredSubData = allSubData.filter(
        (sub) => sub.category_id === categoryId
      );
      setSubData(filteredSubData);
    } else {
      setSubData([]);
    }
  }
  const handlePageChange = (newPage) => {
    setPage(newPage);
    setCurrentPage(newPage + 1); 
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPageSize(newRowsPerPage);
    setPage(0);
    setCurrentPage(1);
  };
  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      minWidth: 70,
      maxWidth: 100,
      headerAlign: 'center',
      align: 'center',
      sortable: false
    },
    {
      field: "otName",
      headerName: "Outlet Name",
      width: 100,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },

    {
      field: "code",
      headerName: "Product Barcode",
      // flex: 1,
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 180,
    },
    {
      field: "item",
      headerName: "Product Description",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 180,
    },
    {
      field: "category",
      headerName: "Category",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 180,
    },
    {
      field: "subcategory",
      headerName: "SubCategory",
      width: 100,
      minWidth: 200,
      width: 280,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "qty",
      headerName: "Qty",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "amt",
      headerName: "Amount",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "right",
      sortable: false,
      renderCell: (params) => (
        <strong>{params.value}</strong>
      ),
    },
    {
      field: "actualot",
      headerName: "Actual Outlet",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "scannedby",
      headerName: "Scanned By",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "errorcode",
      headerName: "Error Code",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "errormsg",
      headerName: "Error Message",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "createdat",
      headerName: "Created At",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },

  ]
  console.log(options.customer != null ? options.customer.fullname : outletName)
  const rows = _.map(data, (val, idx) => ({
    // id: val.prodid,
    id: val.id,
    // sno: idx+1,
    sno: (currentPage - 1) * pageSize + idx + 1,
    code: val.barcode,
    item: val.description,
    qty: val.qty,
    amt: parseFloat(val.mrp).toFixed(0),
    otName: val.outlet_name,
    docno: val.docno,
    scannedby: val.scanned_by_name,
    actualot: val.actual_outlet_name === "No Outlet" ? "Warehouse" : val.actual_outlet_name,
    errorcode: val.error_code,
    errormsg: val.error_message,
    createdat: val.created_at,
    category: val.category_name,
    subcategory: val.subcategory_name

  }))
  const props = {
    columns: columns,
    rows: rows,
    page: page,
    // setPage: setPage,
    setPage: handlePageChange,
    rowsPerPage: rowsPerPage,
    // setRowsPerPage: setRowsPerPage,
    setRowsPerPage: handleRowsPerPageChange,
    pageCount: pageCount,
    pageOption: pageOption,
    totalAmount: totalAmount,
    totalFlag: totalFlag,

  }

  useEffect(() => {
    setTotalFlag(true);
    const total = rows.length;

    setTotalAmount(total);
  }, [rows]);
  function handleChange(e, name) {
    setDateLimit(prev => ({ ...prev, [name]: dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
        const loggedOutletName = localStorage.getItem('outlet_name');
        const userOutlet = res.data.find(outlet => outlet.fullname === loggedOutletName);
        if (userOutlet) {
          setOptions(prev => ({ ...prev, customer: userOutlet }));
        }
        setIsOutletLoading(false);
      })
      .catch((err) => {
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(true, "error", err.response.data.error));
        setIsOutletLoading(false);
      });
  }
  function getCategory() {
    axios.get('/v1/categories')
      .then(res => {
        const activeCats = res.data.filter(val => val.is_active);
        setCatData(activeCats);

      })
      .catch(err => {
        setData([]);
        setRowData(null);
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.error))
      })
  }


  function getSubCategory() {
    axios.get('/v1/subcategories')
      .then(res => {
        // setSubData(res.data)
        setAllSubData(res.data);
      })
      .catch(err => {
        console.log(err)
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(true, 'error', err.response.data.error))
      })
  }
  function handleOutletSalesItemWise() {
    if (isOutletLoading) return;
    setData([]);
    setRowData(null);
    const postData = {
      from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
      category_name: options.category
        ? options.category.category_name
        : "",

      subcategory_name: options.subCategory
        ? options.subCategory.subcategory_name
        : "",
      outlet_id: options.customer?.id || 0,
      barcode: barcode || "",
    };

    axios.post(`/v1/stock_verify/error_report/${pageSize}/${currentPage}`, postData)
      .then(res => {
        setData(res.data.data);
        setPageCount(res.data.meta?.pagination?.total_pages || 0);
      })

      .catch(err => {
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(
          true,
          "error",
          err.response?.data?.errors?.[0]?.message || "Something went wrong"
        ));
      });
  }


  const generateCSVData = () => {
    const csvData = [
      [
        "S.no",
        "Outlet Name",
        "Product Barcode",
        "Product Description",
        "Category",
        "SubCategory",
        "Qty",
        "Amount",
        "Actual Outlet",
        "Scanned By",
        "Error Code",
        "Error Message",
        "Created At"
      ]
    ];

    rows.forEach(row => {
      csvData.push([
        row.sno,
        row.otName,
        row.code,
        row.item,
        row.category,
        row.subcategory,
        row.qty,
        row.amt,
        row.actualot,
        row.scannedby,
        row.errorcode,
        row.errormsg,
        row.createdat
      ]);
    });

    csvData.push([]);


    return csvData;
  };

  useEffect(() => {
    getSupplierData();
    getCategory()
    getSubCategory()
  }, []);
  useEffect(() => {
    if (dateLimit.fromDate && dateLimit.toDate) {
      handleOutletSalesItemWise();
    }
  }, [
    currentPage,
    pageSize,
    dateLimit.fromDate,
    dateLimit.toDate,
    options.customer,
    options.category,
    options.subCategory,
    barcode,
  ]);

  console.log(rows, "datadata");


  return (
    <Fragment>
      <Helmet><title>Stock Verify Mismatch Report</title></Helmet>
      <Typography variant="h6">Stock Verify Mismatch Report</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            options={[{ id: 0, fullname: "All" }, ...supplier]}
            value={options.customer || null}
            onChange={(e, value) => handleOptions(value, 'customer')}
            getOptionLabel={option => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label: 'From',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label: 'To',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item >
          <TextField
            label="Barcode *"
            variant="outlined"
            value={barcode}
            onChange={(e) => setBarcode(e.target.value)}
            sx={{
              width: 300,
              "& .MuiOutlinedInput-root": {
                height: 42,
                alignItems: "flex-end",
              },
              "& input": {
                padding: "14px 12px 6px 12px",
              },
            }}
          />


        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size='small'
            value={options.category}
            options={catData}
            getOptionLabel={option => option.category_name}
            onChange={(e, value) => handleOptions(value, 'category')}
            renderInput={(params) => (
              <TextField {...params}
                label='Category' />
            )}
          />
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size='small'
            options={subData}
            value={options.subCategory}
            disabled={options.category == null}
            getOptionLabel={option => option.subcategory_name}
            onChange={(e, value) => handleOptions(value, 'subCategory')}
            renderInput={(params) => (
              <TextField {...params}
                label='Sub Category' />
            )}
          />
        </Grid>
        <Grid item md={3}>
          <CSVLink data={generateCSVData()} filename={"StockVerificationMismatch_Reports.csv"}>
            <Button variant="contained" color="primary">
              Download CSV
            </Button>
          </CSVLink>
        </Grid>
      </Grid>
      {activeStep === "0" ?
        <CustomTable props={props} />

        :
        <Grid>
          <></>
        </Grid>
      }
    </Fragment>
  )
}

export default memo(StockverificationMismatchReport)